var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"right":"","max-width":"300"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"ma-2",attrs:{"small":"","icon":"","color":"primary","dark":""}},'v-btn',attrs,false),on),[_c('v-icon',{staticClass:"edit",attrs:{"color":"secondary"}},[_vm._v("mdi-information-outline")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.information))])])}
var staticRenderFns = []

export { render, staticRenderFns }